module.exports = __webpack_public_path__ + "static/media/loginBGMobile.d45e77c8.svg";